import request from '../utils/request';
export function fetchShippingMethods(filters) {
    const params = new URLSearchParams();
    const search = filters?.search?.trim();
    const isFree = filters?.is_free;
    if (search)
        params.append('search', search);
    if (isFree !== undefined)
        params.append('is_free', String(isFree));
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/shipping-methods/?${queryString}`
        : '/api/v1/admin/shipping-methods/';
    return request()
        .get(url)
        .send();
}
export function createShippingMethod(payload) {
    return request()
        .post('/api/v1/admin/shipping-methods/')
        .send(payload);
}
export function updateShippingMethod(id, payload) {
    return request()
        .patch(`/api/v1/admin/shipping-methods/${id}/`)
        .send(payload);
}
export function deleteShippingMethod(id) {
    return request()
        .delete(`/api/v1/admin/shipping-methods/${id}/`)
        .send();
}
